/*
 * Hill St. click tracking (theme side).
 *
 * Listens for clicks on links and buttons anywhere in the page, works out
 * which theme section they sit in, and publishes a `hillst_click` custom
 * event through Shopify's analytics bus. A custom pixel (Settings ->
 * Customer events) subscribes to that event and forwards it to GA4.
 *
 * This file sends nothing to Google itself. If the custom pixel is not
 * connected, the event is published and simply nobody listens.
 */
(function () {
  'use strict';
  if (window.__hillstClicks) return;
  window.__hillstClicks = true;

  // Section key (the part of the wrapper id after "__") -> readable name.
  // Anything not listed falls back to the raw key.
  var SECTION_NAMES = {
    // Home page (templates/index.json)
    'slideshow': 'hero',
    'hillst_trust': 'trust_strip',
    'featured-collection': 'luxury_boxes_row',
    'multicolumn_63CjF7': 'jamie_guardian',
    'featured_collection_FFfj9P': 'creations_row',
    'rich-text': 'born_in_essex_text',
    '176235567132bf786d': 'confectionery_row',
    'image_with_text_bw8FhM': 'bean_to_bar_promo',
    '1767789775242ec770': 'video',
    'blocks_KEdBUt': 'bean_to_bar_row',
    'featured_blog_kwX7Nt': 'blog_posts',
    '1784113273bc05feeb': 'apps',
    '1745613577da2e784f': 'apps',
    '17841079689317b737': 'apps',
    // Header / footer groups
    'header': 'header',
    'announcement-bar': 'announcement_bar',
    'custom_liquid_y3z8QK': 'header_custom',
    'footer': 'footer',
    'newsletter': 'footer_newsletter',
    // Blog articles (templates/article.json)
    'hillst_shop': 'blog_buy_path'
  };

  // Clicks inside these are UI chrome, not engagement we want to measure.
  var IGNORE = [
    '.skip-to-content-link',
    'cart-drawer',
    'cart-notification',
    'quantity-input',
    '.slider-buttons',
    '.slideshow__controls',
    'modal-dialog',
    'details-modal',
    'predictive-search',
    'localization-form',
    '.shopify-payment-button'
  ].join(',');

  function sectionOf(el) {
    var wrap = el.closest('.shopify-section');
    if (!wrap || !wrap.id) return { key: '', name: 'none' };
    var key = wrap.id.split('__').pop();
    return { key: key, name: SECTION_NAMES[key] || key };
  }

  function labelOf(el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) text = (el.getAttribute('aria-label') || '').trim();
    if (!text) {
      var img = el.querySelector('img[alt]');
      if (img) text = img.getAttribute('alt').trim();
    }
    return text.slice(0, 80);
  }

  function kindOf(el) {
    if (el.closest('.card-wrapper')) return 'product_card';
    if (el.closest('.header__inline-menu, .menu-drawer, header-menu, .header__icons')) return 'nav';
    if (el.tagName === 'BUTTON' || el.classList.contains('button') || el.closest('.button')) return 'button';
    return 'link';
  }

  function pageType() {
    var main = document.querySelector('main[data-template]');
    return (main && main.getAttribute('data-template')) || '';
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var el = target.closest('a[href], button');
    if (!el || el.closest(IGNORE)) return;

    var section = sectionOf(el);
    var payload = {
      section: section.name,
      section_key: section.key,
      element: kindOf(el),
      label: labelOf(el),
      href: el.tagName === 'A' ? el.href : '',
      page_type: pageType(),
      path: window.location.pathname
    };

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hillst_click', payload);
      }
    } catch (err) {
      /* never let analytics break the shop */
    }
  }, { capture: true, passive: true });
})();
